import React from 'react';

export function PerformanceFilterBar({ filters, options, onChange }) {
  const set = (patch) => onChange({ ...filters, ...patch });
  return (
    <div className="dashboard-filters">
      <input type="text" placeholder="Search name…" aria-label="Search name"
        value={filters.name || ''} onChange={(e) => set({ name: e.target.value })} />
      <select aria-label="Team Lead" value={filters.teamLead || ''} onChange={(e) => set({ teamLead: e.target.value || null })}>
        <option value="">All team leads</option>
        {options.teamLeads.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
      </select>
      <select aria-label="Country" value={filters.countryId || ''} onChange={(e) => set({ countryId: e.target.value || null })}>
        <option value="">All countries</option>
        {options.countries.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
      </select>
      <select aria-label="Dates" value={filters.dateKey || ''} onChange={(e) => set({ dateKey: e.target.value || null })}>
        <option value="">All dates</option>
        <option value="this-month">This month</option>
        <option value="this-quarter">This quarter</option>
        <option value="this-year">This year</option>
      </select>
      <select aria-label="PI System" value={filters.piSystemId || ''} onChange={(e) => set({ piSystemId: e.target.value || null })}>
        <option value="">All systems</option>
        {options.systems.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
      </select>
    </div>
  );
}
